import type React from 'react';

import { FacecoverV1Details } from './FacecoverV1Details';
import { FacecoverV2Details } from './FacecoverV2Details';
import type { AnalyticDetailsEvent } from '../../types';

interface FacecoverDetailsSelectProps {
  event: AnalyticDetailsEvent;
  version?: string;
}

export function FacecoverDetailsSelect({
  event,
  version = 'v1',
}: FacecoverDetailsSelectProps): React.JSX.Element {
  if (version === 'v2') {
    return <FacecoverV2Details event={event} />;
  }

  return <FacecoverV1Details event={event} />;
}
